import ApiService from './ApiService'
export const AccountService = {

  baseURL: process.env.VUE_APP_CLINICAL_URL,

  get (slug, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/admin/accounts`, slug, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  store (params) {
    return ApiService.post(`${this.baseURL}/admin/accounts`, params)
  },

  update (resource, params) {
    return ApiService.put(`${this.baseURL}/admin/accounts/${resource}`, params)
  },

  destroy (resource) {
    return ApiService.delete(`${this.baseURL}/admin/accounts/${resource}`)
  },

  getHearingTrainingLevels (resource) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/admin/accounts/${resource}/hearing-training`)
        .then(response => {
          resolve(response.data.data)
        })
        .catch(errors => {
          console.log(errors)
          resolve([])
        })
    })
  }
}

export const AccountPermissionsService = {

  baseURL: process.env.VUE_APP_CLINICAL_URL,

  get () {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/admin/accounts-permissions`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },
  store (entityId, data) {
    return ApiService.post(`${this.baseURL}/admin/entities/${entityId}/account-permissions`, data)
  }
}

export const InvitationService = {

  baseURL: process.env.VUE_APP_CLINICAL_URL,

  store (params) {
    return ApiService.post(`${this.baseURL}/admin/invitations`, params)
  }
}
